export const emails = {
  sales_pl: 'bartoszbukalo@dataplace.ai',
  sales_en: 'joannamisiewicz@dataplace.ai',
  customer_service: 'katarzynakaczmarek@dataplace.ai',
}